import React, { useState, useEffect, useRef } from 'react';
import TextTransition, { presets } from 'react-text-transition';
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const slides = [
  {
    image: '/video.mp4',
    title: 'Zanari Analytics',
    paragraph:
      'Transforming data into actionable insights with world-class Business Intelligence and Data Analytics solutions.',
  },
  {
    image:
      'https://img.freepik.com/free-photo/business-analyst-meeting-with-coworker-review-financial-report_482257-123652.jpg?t=st=1756190945~exp=1756194545~hmac=4b7b8aece540a51210b69e072510ced24a4d7ac86305f34a395816e1b60b23fb&w=1480',
    title: 'Data-Driven Decisions',
    paragraph:
      'Empowering organizations to make smarter choices with real-time dashboards, KPIs, and analytics.',
  },
  {
    image: '/2151957101.jpg',
    title: 'Cloud & AI Innovation',
    paragraph:
      'Leveraging cloud computing, AI, and machine learning to unlock growth opportunities and efficiency.',
  },
  {
    image:
      'https://img.freepik.com/free-photo/discussing-busines-report_1098-16536.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740',
    title: 'Comprehensive Solutions',
    paragraph:
      'From BI platforms to custom software and ICT infrastructure, we deliver end-to-end digital transformation.',
  },
];

function AnimatedText({ text, duration = 400 }) {
  const [displayed, setDisplayed] = useState(text);
  const [fade, setFade] = useState(true);
  const prevText = useRef(text);

  useEffect(() => {
    if (prevText.current !== text) {
      setFade(false);
      const timeout = setTimeout(() => {
        setDisplayed(text);
        setFade(true);
        prevText.current = text;
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, [text, duration]);

  return (
    <span
      style={{
        display: 'inline-block',
        width: '100%',
        transition: `opacity ${duration / 2}ms, transform ${duration / 2}ms`,
        opacity: fade ? 1 : 0,
        transform: fade ? 'translateY(0)' : 'translateY(20px)',
      }}
    >
      {displayed}
    </span>
  );
}

export const Header = () => {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const duration = current === 0 ? 15000 : 5000;
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, duration);
    return () => clearTimeout(timeoutRef.current);
  }, [current]);

  const goToSlide = (idx) => setCurrent(idx);

  // Your EmailJS submit handler (unchanged)
  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_801a09m',
        'template_8wq0hwr',
        e.target,
        'XtVOqyd7xYMe69koA'
      )
      .then(
        () => {
          toast.success(
            'Thank you for requesting a demo! We will get back to you shortly.'
          );
          // clearState(); // Uncomment if you have this function defined
          e.target.reset();
          setIsModalOpen(false); // Close modal on success
        },
        () => {
          toast.error('Failed to send request. Please try again.');
        }
      );
  };

  return (
    <header id="header">
      <div className="intro-carousel-outer">
        <div
          className="intro-carousel-inner"
          style={{
            width: `${slides.length * 100}%`,
            transform: `translateX(-${current * (100 / slides.length)}%)`,
            transition: 'transform 1s cubic-bezier(0.77,0,0.175,1)',
          }}
        >
          {slides.map((slide, idx) => (
            <div
              className="intro-carousel-slide"
              key={idx}
              style={{
                position: 'relative',
                width: `${100 / slides.length}%`,
                minHeight: '100vh',
                overflow: 'hidden',
                background:
                  idx === 0
                    ? 'none'
                    : `url('${slide.image}') center center/cover no-repeat`,
              }}
            >
              {idx === 0 ? (
                <>
                  <video
                    src={slide.image}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                    }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(0,0,0,0.5)',
                      zIndex: 1,
                    }}
                  />
                </>
              ) : null}
            </div>
          ))}
        </div>

        <div className="intro-carousel-content">
          <div className="intro-text poppins-font">
            <h1 style={{ fontWeight: 700, marginBottom: 24 }}>
              <AnimatedText text={slides[current].title} />
              <span></span>
            </h1>
            <p style={{ fontWeight: 400, marginBottom: 40 }}>
              <AnimatedText text={slides[current].paragraph} />
            </p>

            <div style={{ marginBottom: 40 }}>
              {slides.map((_, idx) => (
                <span
                  key={idx}
                  onClick={() => goToSlide(idx)}
                  style={{
                    display: 'inline-block',
                    width: 14,
                    height: 14,
                    margin: '0 6px',
                    borderRadius: '50%',
                    background:
                      idx === current ? '#5ca9fb' : 'rgba(255,255,255,0.5)',
                    border:
                      idx === current
                        ? '2px solid #fff'
                        : '2px solid transparent',
                    cursor: 'pointer',
                    transition: 'background 0.4s, border 0.4s',
                  }}
                />
              ))}
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1.85rem',
                flexWrap: 'wrap',
                justifyContent: 'center',
                flexDirection: 'row',
              }}
            >
              {/* Primary CTA */}
              <button
                onClick={() => setIsModalOpen(true)}
                style={{
                  padding: '14px 36px',
                  borderRadius: '999px',
                  border: 'none',
                  fontSize: '1.6rem',
                  fontWeight: 600,
                  background: '#006990',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                Request a Demo
              </button>

              {/* Secondary CTA */}
              <a
                href="#features"
                className="page-scroll"
                style={{
                  padding: '14px 34px',
                  borderRadius: '999px',
                  fontSize: '1.5rem',
                  fontWeight: 600,
                  color: '#ffffff',
                  border: '2px solid rgba(255,255,255,0.7)',
                  textDecoration: 'none',
                  backdropFilter: 'blur(4px)',
                  transition: 'all 0.25s ease',
                }}
              >
                Get in Touch
              </a>
            </div>
            <style>
              {`
@media (max-width: 600px) {
  #header .intro-text > div[style*="display: flex"] {
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 1.25rem !important;
  }
}
`}
            </style>
          </div>
        </div>

        <div className="intro-carousel-overlay" />
      </div>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(30,41,59,0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '1rem',
            backdropFilter: 'blur(4px)',
            fontSize: '1.25rem', // Increased base font size for modal
          }}
          onClick={() => setIsModalOpen(false)}
        >
          <div
            style={{
              background: 'rgba(255,255,255,0.95)',
              borderRadius: '18px',
              maxWidth: '480px',
              width: '100%',
              padding: '2.5rem 2rem 2rem 2rem',
              position: 'relative',
              boxShadow:
                '0 8px 32px rgba(60, 130, 246, 0.18), 0 1.5px 8px rgba(30,41,59,0.10)',
              border: '1px solid rgba(92,169,251,0.10)',
              backdropFilter: 'blur(8px)',
              animation: 'modalPop .35s cubic-bezier(.4,2,.6,1) 1',
              fontSize: '1.8rem', // Increased font size for modal content
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                position: 'absolute',
                top: '1.1rem',
                right: '1.3rem',
                background: 'none',
                border: 'none',
                fontSize: '2.3rem', // Larger close button
                color: '#64748b',
                cursor: 'pointer',
                transition: 'color 0.2s',
              }}
              aria-label="Close"
              onMouseOver={(e) => (e.currentTarget.style.color = '#3b82f6')}
              onMouseOut={(e) => (e.currentTarget.style.color = '#64748b')}
            >
              ×
            </button>

            <h2
              style={{
                marginBottom: '1.1rem',
                fontWeight: 800,
                color: '#1e293b',
                fontSize: '2.3rem', // Larger heading
                letterSpacing: '-1px',
                textAlign: 'center',
              }}
            >
              Request a Demo
            </h2>
            <p
              style={{
                marginBottom: '2rem',
                color: '#64748b',
                textAlign: 'center',
                fontSize: '1.4rem',
              }}
            >
              Fill in your details and we'll get in touch to schedule a
              personalized demo.
            </p>

            <form
              onSubmit={handleSubmit}
              autoComplete="on"
              style={{
                fontSize: '1.25rem', // Increase base font size for the form
                fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                color: '#1e293b',
              }}
            >
              <input type="hidden" name="form_type" value="demo_request" />
              <div style={{ marginBottom: '1.25rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 700,
                    color: '#334155',

                    fontSize: '1.25rem', // Increased label font size
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  }}
                >
                  Full Name <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Your full name"
                  style={{
                    width: '100%',
                    padding: '18px 18px',
                    border: '1.5px solid #e0e7ef',
                    borderRadius: '8px',
                    fontSize: '1.25rem', // Increased input font size
                    background: '#f8fafc',
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                    color: '#1e293b',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    outline: 'none',
                    boxShadow: '0 1px 2px rgba(92,169,251,0.04)',
                  }}
                  onFocus={(e) =>
                    (e.target.style.border = '1.5px solid #3b82f6')
                  }
                  onBlur={(e) =>
                    (e.target.style.border = '1.5px solid #e0e7ef')
                  }
                />
              </div>
              <div style={{ marginBottom: '1.25rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 700,
                    color: '#334155',

                    fontSize: '1.25rem', // Increased label font size
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  }}
                >
                  Business Email <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="you@company.com"
                  style={{
                    width: '100%',
                    padding: '18px 18px',
                    border: '1.5px solid #e0e7ef',
                    borderRadius: '8px',
                    fontSize: '1.25rem', // Increased input font size
                    background: '#f8fafc',
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                    color: '#1e293b',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    outline: 'none',
                    boxShadow: '0 1px 2px rgba(92,169,251,0.04)',
                  }}
                  onFocus={(e) =>
                    (e.target.style.border = '1.5px solid #3b82f6')
                  }
                  onBlur={(e) =>
                    (e.target.style.border = '1.5px solid #e0e7ef')
                  }
                />
              </div>
              <div style={{ marginBottom: '1.25rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 700,
                    color: '#334155',

                    fontSize: '1.25rem', // Increased label font size
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  }}
                >
                  Company / Organization
                </label>
                <input
                  type="text"
                  name="company"
                  placeholder="Company or organization"
                  style={{
                    width: '100%',
                    padding: '18px 18px',
                    border: '1.5px solid #e0e7ef',
                    borderRadius: '8px',
                    fontSize: '1.25rem', // Increased input font size
                    background: '#f8fafc',
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                    color: '#1e293b',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    outline: 'none',
                    boxShadow: '0 1px 2px rgba(92,169,251,0.04)',
                  }}
                  onFocus={(e) =>
                    (e.target.style.border = '1.5px solid #3b82f6')
                  }
                  onBlur={(e) =>
                    (e.target.style.border = '1.5px solid #e0e7ef')
                  }
                />
              </div>
              <div style={{ marginBottom: '1.25rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 700,
                    color: '#334155',

                    fontSize: '1.25rem', // Increased label font size
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  }}
                >
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone (optional)"
                  style={{
                    width: '100%',
                    padding: '18px 18px',
                    border: '1.5px solid #e0e7ef',
                    borderRadius: '8px',
                    fontSize: '1.25rem', // Increased input font size
                    background: '#f8fafc',
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                    color: '#1e293b',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    outline: 'none',
                    boxShadow: '0 1px 2px rgba(92,169,251,0.04)',
                  }}
                  onFocus={(e) =>
                    (e.target.style.border = '1.5px solid #3b82f6')
                  }
                  onBlur={(e) =>
                    (e.target.style.border = '1.5px solid #e0e7ef')
                  }
                />
              </div>
              <div style={{ marginBottom: '1.75rem' }}>
                <label
                  style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 700,
                    color: '#334155',

                    fontSize: '1.25rem', // Increased label font size
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  }}
                >
                  Tell us about your needs
                </label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="e.g., Interested in Power BI dashboards, AI chatbot, or data warehouse setup..."
                  style={{
                    width: '100%',
                    padding: '18px 18px',
                    border: '1.5px solid #e0e7ef',
                    borderRadius: '8px',
                    fontSize: '1.25rem', // Increased textarea font size
                    background: '#f8fafc',
                    fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                    color: '#1e293b',
                    resize: 'vertical',
                    transition: 'border 0.2s, box-shadow 0.2s',
                    outline: 'none',
                    boxShadow: '0 1px 2px rgba(92,169,251,0.04)',
                    minHeight: '110px',
                  }}
                  onFocus={(e) =>
                    (e.target.style.border = '1.5px solid #3b82f6')
                  }
                  onBlur={(e) =>
                    (e.target.style.border = '1.5px solid #e0e7ef')
                  }
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                style={{
                  width: '100%',
                  background: '#006990',
                  color: '#fff',
                  border: 'none',
                  padding: '22px',
                  borderRadius: '9px',
                  fontSize: '1.35rem', // Increased button font size
                  fontWeight: 700,
                  fontFamily: "'Montserrat', 'DM Sans', Arial, sans-serif",
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px rgba(92,169,251,0.13)',

                  transition: 'background 0.2s, box-shadow 0.2s',
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = '#005377')
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = '#006990')
                }
              >
                Submit Demo Request
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
};
